import { getShowModalFromWindowOrDefault } from '../FlowWebProvider/FlowWebInternal';
export var showModal = function showModal() {
  var sharedShowModal = getShowModalFromWindowOrDefault();
  sharedShowModal.apply(void 0, arguments);
};